import HeadHeroCard from "./HeadHeroCard";
import HeadHeroCardM from "./HeadHeroCardM";

export { HeadHeroCard, HeadHeroCardM };
